import React, { useEffect, useState } from 'react';
import { Tabs, Card, Row, Col, Table, Button, Tag, Form, Modal, Skeleton, Input, DatePicker, Select, Upload, Image, AutoComplete, Dropdown, Menu } from "antd";
import {
    SearchOutlined, SettingOutlined, LockOutlined, MenuOutlined, UnlockOutlined, PlusOutlined, EditOutlined, ContactsOutlined, PlusSquareOutlined, UserOutlined, PhoneFilled, MailFilled, FileExcelOutlined, DeleteOutlined, TeamOutlined, FormOutlined, SkinOutlined, CheckOutlined
} from "@ant-design/icons";
import swal from "sweetalert";

import './bank.css';

const { Option } = Select
const BlankPage = () => {

    return (
        <div>
            test
        </div>
    )
}
export default BlankPage